
































































import Vue from "vue";

export default Vue.extend({
  name: "NotificationGDPR",
  data: () => {
    return {
      baseUrl: process.env.VUE_APP_VELLO_URL as string,
      show: false
    };
  },
  mounted() {
    if (
      typeof window !== "undefined" &&
      localStorage.getItem("GDPR-accepted") === null
    ) {
      this.show = true;
    }
  }
});
